var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2505 10.936H19.6403C21.4918 10.936 22.0421 11.2015 21.9975 12.5198C21.9237 14.7034 20.939 17.2407 17 17.936",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94627 21.0505C2.57185 18.4561 2.07468 14.7761 2.00143 10.9362C1.96979 9.27734 2.45126 8.93604 4.65919 8.93604L15.3408 8.93604C17.5487 8.93604 18.0302 9.27733 17.9986 10.9362C17.9253 14.7761 17.4281 18.4561 14.0537 21.0505C13.0934 21.7888 12.2831 21.936 10.9194 21.936H9.08064C7.71686 21.936 6.90658 21.7888 5.94627 21.0505Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3089 2.93604C10.7622 3.27464 10.0012 4.43604 10.0012 5.93604M7.53971 4.43604C7.53971 4.43604 7 4.93604 7 5.93603M14.0012 4.43604C13.7279 4.60534 13.5 5.43604 13.5 5.93603",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeIcon);
export default __webpack_public_path__ + "static/media/coffee-icon.06a232275b9350d1c81be385c44a9c00.svg";
export { ForwardRef as ReactComponent };